export default __webpack_public_path__ + "static/artistBox-poma-pon-89fb2de2e831f4cabf337f7e51d51b2c.png";